import React, { Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import { ToastProvider } from './components/ui/ToastProvider';
import { DialogProvider } from './components/ui/DialogProvider';
import CrmLogin from './components/CrmLogin';
import CRMDashboard from './components/CRMDashboard';
import { fetchSiteBranding } from './lib/branding';

export default function App() {
  useEffect(() => {
    fetchSiteBranding();
  }, []);

  return (
    <GlobalErrorBoundary>
      <ToastProvider>
        <DialogProvider>
          <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>Loading Interface...</div>}>
            <Routes>
              <Route path="/" element={<CrmLogin />} />
              <Route path="/login" element={<CrmLogin />} />
              <Route path="/:slug" element={<CRMDashboard />} />
              <Route path="/services/crm/:slug" element={<CRMDashboard />} />
              <Route path="*" element={<CrmLogin />} />
            </Routes>
          </Suspense>
        </DialogProvider>
      </ToastProvider>
    </GlobalErrorBoundary>
  );
}
